import { GetStaticProps } from 'next';

import bluebonnetFrontpageImage from '../../assets/images/bluebonetfontpage.png';
import BluebonnetLandingContent from '../../components/_organisms/BluebonnetLandingContent';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { DefaultLocale } from '../../providers/tolgee';

interface Props {
  isAuthenticated: boolean;
}

const BluebonnetLandingPage = ({ isAuthenticated }: Props) => {
  return (
    <LandingPageLayout
      title="The Curipod + Texas Bluebonnet Curriculum"
      ogTitle="Bluebonnet is the curriculum. Curipod is the engagement and insights layer."
      subTitle="Student engagement. Rigorous writing practice. Clarity and insights district leaders need."
      image={bluebonnetFrontpageImage}
      disableHeadline={true}
    >
      <BluebonnetLandingContent variant="default" isAuthenticated={isAuthenticated} />
    </LandingPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default BluebonnetLandingPage;
